import React, { useEffect, useState } from "react";
import { auth, firestore } from "./firebase";
import { collection, getDocs } from "firebase/firestore";
import { signInAnonymously, signOut } from "firebase/auth";

import { defaultStation } from "./defaultStation";

export const DataHandler = function DataHandler({ children }) {

    const [stations, setStations] = useState();
    useEffect(() => {

        if (!auth.currentUser) {
            signInAnonymously(auth)
                .then(() => (getStations({ setStations })));
        } else {
            getStations({ setStations });
        }
        return () => {
            signOut(auth);
        };
    }, []);

    // useEffect(() => {
    //     let unsubscribe = null;
    //     if (!auth.currentUser) {
    //         signInAnonymously(auth)
    //             .then(() => (unsubscribe = getAds()));
    //     } else {
    //         unsubscribe = getAds();
    //     }
    //     return () => {
    //         unsubscribe && unsubscribe();
    //     };
    // }, []);

    // useEffect(() => {
    //     let unsubscribe = null;
    //     if (!auth.currentUser) {
    //         signInAnonymously(auth)
    //             .then(() => (unsubscribe = getConfig()));
    //     } else {
    //         unsubscribe = getConfig();
    //     }

    //     return () => {
    //         unsubscribe && unsubscribe();
    //     };
    // }, []);



    if (!stations) {
        return null;
    }
    return (<div style={{ display: 'flex', flexDirection: 'column' }} >
        <div style={{ justifyContent: 'center' }}>
            <img src={stations[0].image} width="50%" height="50%" />
        </div>
        <div style={{ justifyContent: 'center' }}>
            {!children ? null : React.cloneElement(children, { ...children.props, src: `${stations[0].ip}/;` })}
        </div>
    </div>);
};

function getConfig() {
    return collection(firestore, "app-configurations")
        .doc("adsConfig")
        .onSnapshot((stapshot) => {
            // alert("updateAdsConfigContent")
            // console.log("stapshot.docs-updateAdsConfigContent-->", stapshot);
            getAdsConfigContent(stapshot);
        });
}

async function getStations({ setStations }) {

    // console.log("auth().currentUser---AFTER->", auth().currentUser?.isAnonymous)
    const result = await getDocs(collection(firestore, "stations"));
    const arr = [];

    result.forEach((doc) => {

        // console.log(`${doc.id} => ${doc.data()}`);
        if (!doc) {
            return;
        }

        const data = doc.data();

        arr.push({ ...data, id: doc.id, disabled: !!data.disabled });
    });

    if (!arr.length) {
        arr.push(defaultStation);
    }

    const sortedArr = arr.sort((a, b) => a.order - b.order);
    setStations && setStations(sortedArr);
    return sortedArr;
}

function getAds() {
    const ads = getDocs(collection(firestore, "ads"));
    const arr = [];
    ads.forEach((doc) => {
        // console.log(`${doc.id} => ${doc.data()}`);
        arr.push(doc.data());
    });
    // .then((stapshot) => {
    //     // alert("updateAdsContent")
    //     console.log("stapshot.docs--updateAdsContent--->");
    //    // getAdsContent(stapshot);
    // });
}

async function getAdsContent(stapshot) {

    let resultAds = stapshot;
    if (!resultAds) {
        resultAds = await getDocs(collection(firestore, "ads"));
    }

    //  const resultAdsData = resultAds.data()
    // console.log("resultAdsData---->", resultAdsData)
    const ads = [];
    resultAds.forEach((item) => {
        const itemData = item.data();
        // console.log("itemData---resultAds->", itemData)
        ads.push({ ...itemData, maxTime: +itemData.maxTime || 0 });
    });
    // console.log("resultAdsData--ads-->", JSON.stringify(ads))
    // store.ads && detach(store.ads);

    // store.ads = ads || [];
    // console.log("resultAdsData--ads-->", JSON.stringify(store.ads))
}

async function getAdsConfigContent(stapshot) {

    // console.log("auth().currentUser---AFTER->", auth().currentUser?.isAnonymous)
    // let result = stapshot;

    // if (!result) {
    //     result = await collection(firestore, "app-configurations").doc("adsConfig").get();
    // }
    // const resultData = result.data();

    // const maxHeight = convertStringToNumber(resultData.maxHeight, ScreenHeight);

    // store.adsConfig && detach(store.adsConfig);

    // store.adsConfig = {
    //     maxHeight,
    //     maxHeightOR: resultData.maxHeight,
    //     adMaxTime: +resultData.adMaxTime || 0,
    //     borderStyle: resultData.borderStyle,
    //     disabled: resultData.disabled || false,
    //     showAdOnHome: !!resultData.showAdOnHome,
    //     showAdOnPlayer: !!resultData.showAdOnPlayer,
    // };
}